import { BrowserRouter as Router } from 'react-router-dom';
import { RootRoutes } from './pages/_config';
import Providers from './Providers/Providers';

function App() {
  return (
    <Providers>
      <Router>
        <RootRoutes />
      </Router>
    </Providers>
  );
}

export default App;
